/* global axios */
import ApiClient from './ApiClient';

class CustomThemesAPI extends ApiClient {
  constructor() {
    super('custom_themes', { accountScoped: true });
  }

  create(data) {
    return axios.post(this.url, data);
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, data);
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }
}

export default new CustomThemesAPI();
